import * as React from "react";
import styles from "../../../app/components/main/dashboard/join-window/AppNotFoundModal.module.css";

const CrossIcon = () => (
  <svg style={{ color: 'var(--brand, #365d7e)' }}     className={styles.crossIcon}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="#EFEEF5" rx="12"></rect>
    <g clipPath="url(#clip0_86_79)">
      <path
        fill="currentColor"
        d="m12.916 12.008 3.894-3.894a.647.647 0 1 0-.916-.916L12 11.092 8.106 7.198a.647.647 0 1 0-.916.916l3.894 3.894-3.894 3.894a.647.647 0 1 0 .916.916L12 12.924l3.894 3.894a.646.646 0 0 0 .916 0 .647.647 0 0 0 0-.916z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_86_79">
        <path fill="#fff" d="M7 7h10v10H7z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CrossIcon;
